
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Alert } from "@/addons/Alert";
import { DateTime } from "luxon";
import { useConsultorioStore } from '@/store/consultorioStore';
import { globalStore } from '@/store/globalStore';
import { consultorioService } from '@/services/ConsultorioService';
import { http } from "@/config/HttpClient";
import { AxiosResponse } from "axios";

@Component({
	name: "RecetasIndex",
})

export default class RecetasIndex extends Vue {
	@Prop() paciente_id!: any
	private globalStore = globalStore();
	private consultorioStore = useConsultorioStore();
	private consultorioService = consultorioService.getInstance();
	
	detalleInterface = {
		medicamento: String,
		posologia: String
	}
	valid = true;
	fecha = DateTime.now().toFormat('yyyy-MM-dd');
	receta = {
		fecha: DateTime.now().toFormat('yyyy-MM-dd'),
		cita_id: null 
	}
	recetas = []
	detalles = []
	mounted() {
		this.getRecetas()
	}
	async getRecetas() {
		let data = {
			paciente_id: this.paciente_id
		}
		this.consultorioStore.loading = true;
		await http.get(`recetas`, {params: data}).subscribe({
			next: (response:AxiosResponse) => {
				this.recetas = response.data;
				this.consultorioStore.loading = false;

			},
		})
	}
	addItem() {
		this.detalles.push({medicamento: '', posologia: ''})
	}
	deleteItem(index:number) {
		console.log(index)
	}
	guardar() {
		if (!this.$refs.form.validate()) {
			Alert.warning( `Lene todos los campos obligatorios (*)`)
				return;
			}
      
		Alert.confirm(`Se realizará el registro de la receta`, 'Guardar Receta?').then(async result => {
				if(result.isConfirmed){
					let data = {
						fecha: this.receta.fecha,
						cita_id: this.receta.cita_id,
						detalles: this.detalles,
						paciente_id: this.paciente_id
					}
					this.consultorioService.storeReceta(data).then(response =>{
						this.getRecetas();
					} )
				}
		})
	}
	selectItem(detalle:any){
		this.detalles = detalle
	}

	get loading(): boolean {
		return this.consultorioStore.loading;
	}
	get citas(): any {
		return this.consultorioStore.citas;
	}
	imprimir = (id:number) => {
		return this.consultorioService.imprimirSolicitud(id)
	}
	
	
}

